import http from '@/utils/http';
import axios from 'axios';
import { getAuthorization } from '@/utils/utils';

const baseUrl = '/api/v1/intelligence_pc/market_profile';

export function getPageDataNew(url: string, params: any): Promise<any> {
  return http(`/api/v1/intelligence_pc/${url}`, {
    method: 'post',
    data: params,
    timeout: 5 * 60 * 1000,
    rawData: true,
  });
}

export function getPageData(url: string, params: any): Promise<any> {
  return http(`${baseUrl}/${url}`, {
    method: 'post',
    data: params,
    timeout: 5 * 60 * 1000,
  });
}

export function downloadExcel(url: string, params: any) {
  return axios(`${baseUrl}/${url}`, {
    method: 'post',
    data: params,
    responseType: 'blob',
    responseEncoding: 'utf8',
    timeout: 5 * 60 * 1000,
    headers: {
      Authorization: getAuthorization() || '',
    },
  });
}

// MarketProfile国家筛选器
export function getMarketProfileFilterMarket(params: any) {
  return http('/api/v1/intelligence_pc/market_profile/filterMarketList', {
    method: 'post',
    data: params,
  });
}

// MarketProfile 详情 stats搜索(疑似已废弃)
export function getGenreProfileData(params: any) {
  return http('/api/v1/intelligence_pc/market_profile/genre/game/search', {
    method: 'post',
    data: params,
  });
}

// MarketProfile 详情 stats搜索
export function getTotalTrendData(params: any) {
  return http('api/v1/intelligence_pc/market_profile/pc_console_trend', {
    method: 'post',
    data: params,
  });
}

export type TEntityType = 'mobile' | 'pc' | 'console' | 'combine' | 'company';
export type TDataSource = 'appannie' | 'sensortower';
export type TPlatform = 'appstore' | 'googleplay';

export type TGranularity = 'daily' | 'weekly' | 'monthly';
export type TOrder = 'asc' | 'desc';
export type TOrderMetrics = 'revenue' | 'download' | 'game_count';

export interface IMarketProfileMobilePageData {
  source_metrics: Record<string, string[]>;
  granularity: TGranularity;
  start_date?: string;
  end_date?: string;
  regions?: string[];
  platforms: string[];
  metrics: string[];
  genres?: string[];
  b_group_by_genre?: boolean;
  b_group_by_market?: boolean;
  b_gouup_by_region?: boolean;
  b_group_by_date?: boolean;
  b_group_by_platform?: boolean;
  b_growth_ratio?: boolean;
}

export interface IMarketProfileStatsTable {
  entity_type: TEntityType;
  granularity: TGranularity;
  start_date?: string;
  end_date?: string;
  market: string;
  order: TOrder;
  b_ratio: boolean;
  order_metric: TOrderMetrics;
  order_source: TDataSource;
  page: number;
  page_size: number;
  sources: TDataSource[];
  keyword?: string;
  // mobile games专用
  iegg_genre_req?: any[];
}

export interface IMarketProfileStatsCharts {
  entity_type: TEntityType;
  granularity: TGranularity;
  start_date?: string;
  end_date?: string;
  market: string;
  sources: TDataSource[];
  select_code: string[];
  // mobile games专用
  iegg_genre_req?: any[];
}

export function getMobilePageData(params: IMarketProfileMobilePageData) {
  return http('/api/v1/intelligence_pc/mobileIeggGenreMetrics', {
    method: 'post',
    data: params,
    rawData: true,
  });
}

export function getMobileStatsCompanyTable(params: IMarketProfileStatsTable) {
  return http('/api/v1/intelligence_pc/mobileCompany', {
    method: 'post',
    data: params,
    rawData: true,
  });
}

export function getMobileStatsCompanyChart(params: IMarketProfileStatsCharts) {
  return http('/api/v1/intelligence_pc/mobileCompanyTrend', {
    method: 'post',
    data: params,
    rawData: true,
  });
}

export function getMobileStatsGameTable(params: IMarketProfileStatsTable) {
  return http('/api/v1/intelligence_pc/mobileGames', {
    method: 'post',
    data: params,
    rawData: true,
  });
}

export function getMobileStatsGameChart(params: IMarketProfileStatsCharts) {
  return http('/api/v1/intelligence_pc/mobileGamesTrend', {
    method: 'post',
    data: params,
    rawData: true,
  });
}


export type TRankDateItem = {
  metric_name: string;
  cur_date: string;
  last_date: string;
  granularity: TGranularity;
  data_source: string;
};

// MarketProfile Overview > Mobile Games > Global Performance 的排名数据
export function getMobileGenreMarketRankData(params: {
  market: string;
  rank_date_map: TRankDateItem[];
}) {
  return http('/api/v1/intelligence_pc/mobileIeggGenreMarketRank', {
    method: 'post',
    data: params,
    rawData: true,
  });
}

// MarketProfile Detail > Insights > New Release Games 的游戏数据
export function getMobileNewReleaseGames(params: { entity_type: TEntityType; market: string }) {
  return http('/api/v1/intelligence_pc/mobileNewReleaseGames', {
    method: 'post',
    data: params,
    rawData: true,
  });
}

// Market_profile_mobile新接口
export function getMarketProfileMobileData(params: any) {
  return http('/api/v1/intelligence_pc/mobileIeggGenreMetrics', {
    method: 'post',
    data: params,
  });
}

// MarketProfile Detail > Stats > 获取 mobile 游戏公司及国家信息
export function getMobileCompany(params: {
  entity_type: TEntityType;
  start_date?: string;
  end_date?: string;
  granularity: TGranularity;
  market: string;
  order: TOrder;
  b_ratio: boolean;
  order_source: string;
  source: string[];
  order_metric: TOrderMetrics;
  page: number;
  page_size: number;
  keywords?: string;
}) {
  return http('/api/v1/intelligence_pc/mobileCompany', {
    method: 'post',
    data: params,
    rawData: true,
  });
}

// MarketProfile Detail > Stats > 获取 mobile 游戏公司趋势数据
export function getMobileCompanyTrend(params: {
  entity_type: TEntityType;
  granularity: TGranularity;
  start_date: string;
  end_date: string;
  market: string;
  order: TOrder;
  order_metric: TOrderMetrics;
  b_ratio: boolean;
  source: string[]; // 数据源
  select_code: string[]; // 公司 ID
}) {
  return http('/api/v1/intelligence_pc/mobileCompanyTrend', {
    method: 'post',
    data: params,
    rawData: true,
  });
}

// MarketProfile Detail > Stats > 获取 mobile 游戏公司下载 ids
export function getMobileCompanyPagesIDs(params: {
  entity_type: TEntityType;
  granularity: TGranularity;
  start_date: string;
  end_date: string;
  market: string;
  order: TOrder;
  b_ratio: boolean;
  order_source: string;
  order_metric: TOrderMetrics;
  page: number;
  page_size: number;
  sources: string[];
}) {
  return http('/api/v1/intelligence_pc/mobileCompanyPagesIDs', {
    method: 'post',
    data: params,
    rawData: true,
  });
}

// MarketProfile Detail > Stats > 获取 mobile 游戏下载游戏 ids
//
export function getMobileGamesPagesIDs(params: {
  market: string;
  entity_type: TEntityType;
  genre: string[];
  data_tag: string;
  start_date: string;
  end_date: string;
  page: number;
  page_size: number;
  order: TOrder;
  order_source: string;
  granularity: TGranularity;
  sources: string[];
}) {
  return http('/api/v1/intelligence_pc/mobileGamesPagesIDs', {
    method: 'post',
    data: params,
    rawData: true,
  });
}
